/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { Node } from '@msdyn365-commerce-modules/utilities';
import { IMfrmProductOverviewViewProps } from './mfrm-product-overview';

export default (props: IMfrmProductOverviewViewProps) => {
    const { productOverviewText } = props;
    const {productOverviewHeadingText} =props.resources;
    return (
        <>
            {productOverviewText && <Node className='product-overview__container'>
                <Node className='product-overview__heading'>
                    <h2>{productOverviewHeadingText}</h2>
                </Node>
                <Node className='product-overview__description'>
                    <Node className='' dangerouslySetInnerHTML={{ __html: productOverviewText }}/>
                </Node>
            </Node>
            }
        </>
    );
};
